<template>
  <div v-loading="loading" class="kc_add_pupop">
    <div class="add_pupop_form">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="100px"
      >
        <el-form-item label="化学品:" prop="value">
          <el-input v-if="type == 'query'" v-model="form.hxpMc" style="width: 273px" disabled />
          <el-cascader
            v-else
            v-model="value"
            :props="{ emitPath: false }"
            style="width: 273px"
            :show-all-levels="false"
            :options="options"
            @change="handleChange"
          />
        </el-form-item>
        <el-form-item label="仓库:" prop="ckId">
          <el-input v-if="type == 'query'" v-model="form.ckmc" style="width: 273px" disabled />
          <el-select
            v-else
            v-model="form.ckId"
            style="width: 273px"
            placeholder="请选择"
          >
            <el-option
              v-for="item in cangkuList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
              @click.native="cangkuClickChange(item)"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="初始库存量:" prop="cskc">
          <div style="width: 273px">
            <el-input
              v-model="form.cskc"
              :disabled="type == 'query' || isCcdw"
              style="width: 65%"
              placeholder="请输入"
            />
            <el-select
              v-model="form.cskcDw"
              :disabled="type == 'query'"
              style="width: calc(35% - 10px); margin-left: 10px"
              placeholder="单位"
              @change="changedw"
            >
              <el-option
                v-for="item in dwByHxpList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="保管员:">
          <el-input
            v-model="form.bgyxm"
            disabled
            style="width: 273px"
            placeholder=""
          />
        </el-form-item>
        <el-form-item label="保管员电话:">
          <el-input
            v-model="form.bgydh"
            disabled
            style="width: 273px"
            placeholder=""
          />
        </el-form-item>

        <el-form-item label="登记人:" prop="djrLabel">
          <el-input
            v-model="form.djrLabel"
            disabled
            style="width: 273px"
          />
        </el-form-item>
        <el-form-item
          label="备注:"
          style="width: 100%"
          prop="bz"
          :rules="{
            validator: (rule, value, callback) => {
              lengthValidate(rule, value, callback, 'xt', 225);
            },
            trigger: ['blur', 'change'],
          }"
        >
          <el-input
            v-model="form.bz"
            :disabled="type == 'query'"
            style="width: 100%"
          />
        </el-form-item>
        <template v-if="isCcdw">
          <el-form-item
            v-for="(item, index) in wtform"
            :key="index"
            label="委托单位:"
            style="width: 100%"
            prop="wtDwMc"
          >
            <el-select
              v-model="item.wtDwMc"
              clearable
              filterable
              :disabled="type == 'query'"
              style="width: 250px"
              placeholder="请选择往来单位"
              @blur="selectBlur($event,index)"
              @change="selectChange($event,index)"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-input-number
              v-model="item.kcl"
              :disabled="type == 'query'"
              placeholder="库存量"
              :min="0"
              style="margin-left: 10px; margin-right: 10px"
              @change="numChange"
            />
            <el-select
              :value="item.kclDw"
              style="width: 140px"
              disabled
              placeholder="单位"
            >
              <el-option
                v-for="item in yzd_nsjsl_dw"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <el-button
              :disabled="type == 'query'"
              type="primary"
              style="margin-left: 10px"
              icon="el-icon-plus"
              circle
              @click="addwt(index)"
            />
            <el-button
              :disabled="type == 'query'"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="delwt(index)"
            />
          </el-form-item>
        </template>
      </el-form>
      <div class="buttonList">
        <el-button
          v-if="type == 'query'"
          class="queding"
          type="primary"
          @click="queding"
        >
          确定
        </el-button>
        <el-button
          v-if="type == 'add'"
          type="primary"
          class="zsbc"
          @click="TempZSsave"
        >暂时保存</el-button>
        <el-button
          v-if="type == 'add'"
          class="tijiao"
          type="primary"
          @click="ZSsave('01', '是否提交?', '提交成功!')"
        >提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { lengthValidate } from '@/assets/js/validate'
import {
  addOrUpdSave,
  getCkxxByCskc,
  getHxpCascader,
  detail,
  userInfo,
  getDwByHxp,
  pdSfCcqy, addOrUpdSaveTemp
} from '@/assets/js/kccsh'
import {
  getWTDW
} from '@/assets/js/ccgl'
import { getkv } from '@/assets/js/common.js'

export default {
  components: {},
  props: {
    type: String,
    rowID: String,
    lc: Number
  },
  data() {
    const huaxuepin = (rule, value, callback) => {
      if (!this.value || this.value.length == 0) {
        return callback(new Error('请选择化学品'))
      } else {
        callback()
      }
    }
    const kucunliang = (rule, value, callback) => {
      if (!this.form.cskc || this.form.cskc.length == 0) {
        return callback(new Error('请输入初始库存量'))
      }
      if (/^[1-9]\d{0,8}(\.\d{1,3})?$|^0(\.\d{1,3})?$/.test(value) == false) {
        callback(new Error('整数位最大9位,保留3位小数'))
      }
      if (this.form.cskcDw == '') {
        return callback(new Error('请输入初始库存量单位'))
      }
      callback()
    }

    const wtdwValidator = (rule, value, callback) => {
      if (!this.form.bgyxm || this.form.bgyxm.length == 0) {
        return callback(new Error('请输入委托单位'))
      } else {
        callback()
      }
    }
    const baoguanyuan = (rule, value, callback) => {
      if (!this.form.bgyxm || this.form.bgyxm.length == 0) {
        return callback(new Error('请输入保管员'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        value: [
          { validator: huaxuepin, required: true, trigger: ['blur', 'change'] }
        ],
        ckId: [
          {
            required: true,
            message: '请选择仓库',
            trigger: ['blur', 'change']
          }
        ],
        cskc: [
          {
            required: true,
            validator: kucunliang,
            trigger: ['blur', 'change']
          }
        ],
        bgy: [
          {
            validator: baoguanyuan,
            required: true,
            trigger: ['blur', 'change']
          }
        ],
        djrLabel: [
          {
            required: true,
            message: '请输入登记人',
            trigger: ['blur', 'change']
          }
        ],
        djsj: [
          {
            required: true,
            message: '请输入登记时间',
            trigger: ['blur', 'change']
          }
        ],
        wtDwMc: [
          {
            validator: wtdwValidator,
            required: true,
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: true,
      value: [],
      yzd_nsjsl_dw: [],
      dwByHxpList: [],
      bgy: '',
      form: {
        id: '',
        dwId: '',
        kccshBh: '',
        ckId: '',
        hxpBm: '',
        cskc: '',
        cskcDw: '',
        bz: '',
        djsj: '',
        djrLabel: '',
        zt: '',
        bgyxm: '',
        hxpMc: '',
        ckmc: ''
      },
      options: [],
      cangkuList: [],
      isCcdw: false, // 是否为仓储单位
      // 委托单位
      options2: [],
      wtform: [
        {
          wtDwMc: '',
          kcl: undefined,
          kclDw: ''
        }
      ]
    }
  },
  computed: {},
  watch: {
    value(newValue, oldValue) {
      if(newValue){
        getDwByHxp(newValue).then((e) => {
          this.dwByHxpList = e.data.data
        })
      }
      this.form.hxpBm = newValue
    }
  },
  created() {
    if (this.rowID) {
      detail(this.rowID).then((e) => {
        this.loading = false
        this.value = e.data.data.hxpBm
        this.form.kccshBh = e.data.data.kccshBh
        this.form.hxpBm = e.data.data.hxpBm
        this.form.id = e.data.data.id
        this.form.dwId = e.data.data.dwId
        this.form.ckId = e.data.data.ckId
        this.form.bgyxm = e.data.data.bgyxm
        this.form.bgydh = e.data.data.bgydh
        this.form.djrLabel = e.data.data.djrLabel
        this.form.djsj = e.data.data.djsj
        this.form.cskc = e.data.data.cskc
        this.form.cskcDw = e.data.data.cskcDw
        this.wtform = e.data.data.storageCsKcList
        this.form.bz = e.data.data.bz
        this.form.hxpMc = e.data.data.hxpMc
        this.form.ckmc = e.data.data.ckmc
        this.$nextTick(() => {
          this.$refs.form.clearValidate() //清楚页面所有校验结果
        })
      })
    } else {
      this.loading = false
      userInfo().then((e) => {
        this.form.djrLabel = e.data.data.name
        this.form.djsj = this.formatLongDate(new Date())
      })
    }
    // 获取仓库信息
    getCkxxByCskc().then((e) => {
      this.cangkuList = e.data.data
    })
    // 获取化学品信息
    getHxpCascader().then((e) => {
      this.options = e.data.data
    })

    getkv('yzd_nsjsl_dw').then((e) => {
      this.yzd_nsjsl_dw = e.data.data
    })
  },
  mounted() {
    pdSfCcqy().then((e) => {
      this.isCcdw = e.data.data
      if (this.isCcdw) {
        getWTDW().then((e) => {
          this.options2 = e.data.data
        })
      }
    })
  },
  methods: {
    lengthValidate,
    selectBlur(e, index) {
      this.wtform[index].wtDwMc = e.target.value
      this.$forceUpdate()
    },
    selectChange(e, index) {
      this.wtform[index].wtDwMc = e
      this.$forceUpdate()
    },
    // 改变数量
    numChange() {
      var num = 0
      for (var i = 0; i < this.wtform.length; i++) {
        if (this.wtform[i].kcl != undefined) {
          num = num + this.wtform[i].kcl
        }
      }
      this.form.cskc = num
    },
    // 新增委托单位
    addwt(i) {
      var new_kclDw
      if (this.wtform[0].kclDw == '') {
        new_kclDw = ''
      } else {
        new_kclDw = this.wtform[0].kclDw
      }

      this.wtform.push({
        wtDwMc: '',
        kcl: undefined,
        kclDw: new_kclDw
      })
    },
    // 删除委托单位
    delwt(i) {
      this.wtform.splice(i, 1)
      this.numChange()
    },
    // 改变单位
    changedw(e) {
      for (var i = 0; i < this.wtform.length; i++) {
        this.wtform[i].kclDw = this.yzd_nsjsl_dw[e - 1].value
      }
    },
    handleChange(val) {},
    cangkuClickChange(data) {
      this.form.bgyId = data.ckbgyId
      this.form.bgyxm = data.ckbgy
      this.form.bgydh = data.ckbgyDh
      this.form.ckmc = data.label
      this.form.bgyxm = data.ckbgy
    },
    queding() {
      this.$parent.$parent.dialogVisible = false
    },
    //暂时保存
    TempZSsave() {
      this.form.zt = '00'
      if (this.isCcdw) {
        this.form.storageCsKcList = this.wtform
      }
      this.$confirm('是否暂时保存?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then((res) => {
          this.loading = true
          addOrUpdSaveTemp(this.form).then(() => {
            this.$parent.$parent.getTableData()
            this.$parent.$parent.dialogVisible = false
            this.$message.success('保存成功！')
            this.loading = false
          }).catch(err => {
            console.log('err', err)
            this.loading = false
          })
        })
        .catch(() => {})
    },
    //入库保存
    ZSsave(type, curConfirmText, tipText) {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.zt = type
          if (this.isCcdw) {
            this.form.storageCsKcList = this.wtform
          }
          this.$confirm(curConfirmText, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          })
            .then((res) => {
              this.loading = true
              addOrUpdSave(this.form).then(() => {
                this.$parent.$parent.getTableData()
                this.$parent.$parent.dialogVisible = false
                this.$message.success(tipText)
                this.loading = false
              }).catch(err => {
                console.log('err', err)
                this.loading = false
              })
            })
            .catch(() => {})
        }
      })
    },
    formatLongDate(date) {
      const myyear = date.getFullYear()
      let mymonth = date.getMonth() + 1
      let myweekday = date.getDate()
      let myHour = date.getHours()
      let myMin = date.getMinutes()
      let mySec = date.getSeconds()

      if (mymonth < 10) {
        mymonth = '0' + mymonth
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday
      }
      if (myHour < 10) {
        myHour = '0' + myHour
      }
      if (myMin < 10) {
        myMin = '0' + myMin
      }
      if (mySec < 10) {
        mySec = '0' + mySec
      }
      return myyear + '-' + mymonth + '-' + myweekday
    }
  }
}
</script>
<style scoped lang="less">
.kc_add_pupop {
  .add_pupop_form {
    .el-form {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .buttonList {
      width: 498px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 40px;
      margin-bottom: 45px;
      display: flex;
      justify-content: center;
      .zsbc {
        margin-right: 190px;
        background-color: #ebebeb;
        width: 104px;
        height: 46px;
        color: #333333;
        border: none;
      }
      .tijiao,
      .queding {
        background-color: #4170ff;
        color: white;
        width: 104px;
        height: 46px;
        border: none;
      }
    }
  }
}
</style>
